const PIANO_TERM_NAMES = Object.freeze({
  DIGITAL_BASIC_ANNUAL: 'Digital - Basic - Annual',
  STANDARD_SELECT_MONTHLY: 'Standard - Select - Monthly',
  REGISTRATION: 'Registration',
  PAID_SUBSCRIPTIONS_KEYWORDS: ['Basic', 'Select', 'Premium'],
  SELECT_SUBSCRIPTION_KEYWORD: 'Select',
  PREMIUM_SUBSCRIPTION_KEYWORD: 'Premium',
  PAID_MEMBERSHIP_KEYWORDS: [
    'Digital - Basic',
    'Standard - Basic',
    'Digital - Select',
    'Standard - Select',
    'Digital - Premium',
    'Standard - Premium',
  ],
})

export default PIANO_TERM_NAMES
